import { MY_STATES } from "@gaole/shared";

type StateSelectProps = {
  label?: string;
  hint?: string;
  value: string;
  onChange: (value: string) => void;
  className?: string;
  required?: boolean;
};

export function StateSelect({ label, hint, value, onChange, className = "", required }: StateSelectProps) {
  return (
    <label className="block">
      {label && <span className="mb-1 block text-xs font-medium text-white/60">{label}</span>}
      <select
        required={required}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`w-full rounded-xl border border-white/10 bg-white/5 px-3.5 py-2.5 text-base text-white outline-none transition-colors focus:border-brand-pink/60 lg:text-sm ${className}`}
      >
        <option value="" className="bg-surface text-white/60">
          Select state
        </option>
        {MY_STATES.map((s) => (
          <option key={s.code} value={s.label} className="bg-surface text-white">
            {s.label}
          </option>
        ))}
      </select>
      {hint && <span className="mt-1 block text-[10px] text-white/40">{hint}</span>}
    </label>
  );
}
